import React from 'react';
import { FullScreenImage } from 'components/UI/FullScreenImage';
import { Grid, GridRow, GridCol } from 'components/UI/Grid';
import { PrismicHTMLParser } from 'components/PrismicHTMLParser';
import { SliceContext } from '../types';
import { FeaturedArtistsCTA } from './FeaturedArtistsCTA';
import { ArtistItems } from '.';

type ArtistProps = {
    artist: ArtistItems;
    sliceContext: SliceContext;
};

export const Artist = (props: ArtistProps) => {
    const {
        featured_artists_title: title,
        featured_artists_cta_label: label,
        featured_artists_cta_link: link,
        featured_artists_description: description,
        featured_artists_image: { localFile },
    } = props.artist;

    if (!localFile || !localFile.childImageSharp) {
        return null;
    }

    return (
        <div className="FeaturedArtists-container">
            <FullScreenImage sizes={localFile.childImageSharp.sizes} />
            <Grid>
                <GridRow
                    horizontalAlign={'h-start'}
                    verticalAlign={'v-center'}
                    className="FeaturedArtists-content"
                >
                    <GridCol colSize={`4`} offsetSize={`0`} mobileColSize={'10'}>
                        <PrismicHTMLParser className="FeaturedArtists-title">
                            {title.html}
                        </PrismicHTMLParser>
                        <PrismicHTMLParser className="FeaturedArtists-description">
                            {description.html || ''}
                        </PrismicHTMLParser>
                        <FeaturedArtistsCTA
                            ctaLabel={label}
                            ctaLink={link}
                            sliceContext={props.sliceContext}
                        />
                    </GridCol>
                </GridRow>
            </Grid>
        </div>
    );
};
